import { createFileRoute } from '@tanstack/react-router'

import { LocationsScreen } from './-components/locations-screen.tsx'

export const Route = createFileRoute('/merchants/locations')({
  component: LocationsScreen
})
